import React from 'react';
import { Space, AddClassBtn, ContainerBtnBox, InputContainer, ContainerBoxRandom} from '../Style/ReferenceImageUpload.style';
import { TextFieldVI } from '../../TextFieldVI';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {Subtitle1} from '../../../ui-library';
import {IProps} from '../../RandomSamplerClasses/Config/RandomImagesAddClass.types';

const RandomImagesAddClass = ({
    getError,
    globalError,
    getValue,
    inputType,
    inputLabel,
    addClass,
    inputcolor,
    isShowBtn,
}:IProps) => (
    <ContainerBoxRandom>
        <>
            <Subtitle1 align='left'>{_SYSTEM_TITLES.addClassTitle}</Subtitle1>
            <Space />
        </>
        <InputContainer>
            <TextFieldVI
                getError={(error) => getError(error)}
                globalError={globalError}
                getValue={(value) => getValue(value)}
                inputType={inputType}
                initValue=''
                inputcolor={inputcolor}
                disabled={false}
                clearValue={false}
                inputLabel={inputLabel} />
        </InputContainer>
        {isShowBtn && <ContainerBtnBox>
            <AddClassBtn variant='contained' size='medium' onClick={() => addClass()}>{_SYSTEM_TITLES.addClassBtn}</AddClassBtn>
        </ContainerBtnBox>}
    </ContainerBoxRandom>
);

export default RandomImagesAddClass;
